import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TooltipControlService {
  public tooltipsDisabled = new BehaviorSubject<boolean>(false);

  public temporarilyDisableTooltips(duration = 100): void {
    this.tooltipsDisabled.next(true);
    setTimeout(() => {
      this.tooltipsDisabled.next(false);
    }, duration);
  }
}
